import React from 'react';
import { Row, Col, Card, Typography, Tag, Space } from 'antd';
import { CarOutlined, StarOutlined } from '@ant-design/icons';
import { shopConfig } from '../../config/shop.config';

const { Title, Text, Paragraph } = Typography;

const BrandsSection: React.FC = () => {
  return (
    <div id="brands" style={{ padding: '80px 20px', backgroundColor: '#ffffff' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <Title level={2}>We Service All Makes & Models</Title>
          <Paragraph style={{ fontSize: '18px', color: '#6b7280', maxWidth: '700px', margin: '0 auto' }}>
            From everyday vehicles to luxury European brands - we have the expertise
          </Paragraph>
        </div>

        <Row gutter={[32, 32]}>
          {/* Popular Brands */}
          <Col xs={24} md={12}>
            <Card
              style={{
                height: '100%',
                borderRadius: '16px',
                border: '2px solid #e5e7eb',
                backgroundColor: '#f0f9ff',
              }}
            >
              <div style={{ marginBottom: '24px' }}>
                <div
                  style={{
                    width: '60px',
                    height: '60px',
                    backgroundColor: '#dbeafe',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '16px',
                  }}
                >
                  <CarOutlined style={{ fontSize: '28px', color: '#2563eb' }} />
                </div>
                <Title level={3} style={{ marginBottom: '8px' }}>
                  Popular Brands
                </Title>
                <Text type="secondary">Reliable service for everyday vehicles</Text>
              </div>

              <Space wrap size={[8, 12]}>
                {shopConfig.brands.simple.map((brand) => (
                  <Tag
                    key={brand.name}
                    style={{
                      padding: '8px 16px',
                      fontSize: '16px',
                      borderRadius: '8px',
                      border: '1px solid #3b82f6',
                      color: '#2563eb',
                      backgroundColor: 'white',
                    }}
                  >
                    {brand.name}
                  </Tag>
                ))}
              </Space>
            </Card>
          </Col>

          {/* Luxury/Complex Brands */}
          <Col xs={24} md={12}>
            <Card
              style={{
                height: '100%',
                borderRadius: '16px',
                border: '2px solid #e5e7eb',
                backgroundColor: '#faf5ff',
              }}
            >
              <div style={{ marginBottom: '24px' }}>
                <div
                  style={{
                    width: '60px',
                    height: '60px',
                    backgroundColor: '#f3e8ff',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '16px',
                  }}
                >
                  <StarOutlined style={{ fontSize: '28px', color: '#7c3aed' }} />
                </div>
                <Title level={3} style={{ marginBottom: '8px' }}>
                  European & Luxury
                </Title>
                <Text type="secondary">Specialized expertise for premium vehicles</Text>
              </div>

              <Space wrap size={[8, 12]}>
                {shopConfig.brands.complex.map((brand) => (
                  <Tag
                    key={brand.name}
                    style={{
                      padding: '8px 16px',
                      fontSize: '16px',
                      borderRadius: '8px',
                      border: '1px solid #7c3aed',
                      color: '#7c3aed',
                      backgroundColor: 'white',
                    }}
                  >
                    {brand.name}
                  </Tag>
                ))}
              </Space>
            </Card>
          </Col>
        </Row>

        {/* All Brands Welcome Message */}
        <div
          style={{
            marginTop: '48px',
            textAlign: 'center',
            padding: '24px',
            backgroundColor: '#f9fafb',
            borderRadius: '12px',
          }}
        >
          <Text style={{ fontSize: '18px', color: '#111827' }}>
            <strong>Don't see your brand?</strong> We service all makes and models - call us to discuss your vehicle's needs!
          </Text>
        </div>
      </div>
    </div>
  );
};

export default BrandsSection;
